import { useEffect, useRef, useState } from "react";
import { classNames } from "../../../helpers/classNames";
import Image from "../Image";
import Indentification from "../Indentification";
import { checkImageByExtention, initialsValue } from "../../../helpers";
import dayjs from "dayjs";
import ChatImage from "./ChatImage";
import { useSocket } from "../../../providers/SocketContext";
import MessageViewer from "./MessageViewer";
import Fancybox from "../Fancybox";

function groupMessages(messages) {
  try {
    if (Array.isArray(messages)) {
      const groupedByDate = {};

      messages.sort((a, b) => new Date(a.time) - new Date(b.time));

      for (const msg of messages) {
        const dateKey = msg.time.split("T")[0]; // YYYY-MM-DD
        if (!groupedByDate[dateKey]) groupedByDate[dateKey] = [];

        const dateGroups = groupedByDate[dateKey];
        const lastGroup = dateGroups[dateGroups.length - 1];

        const msgTime = new Date(msg.time);

        if (
          lastGroup &&
          lastGroup.sendBy === msg.sendBy &&
          (msgTime - new Date(lastGroup.data[lastGroup.data.length - 1].time)) /
            1000 <=
            120
        ) {
          lastGroup.data.push(msg);
          lastGroup.time = msg.time;
        } else {
          dateGroups.push({
            sendBy: msg.sendBy,
            authorizedUserId: msg.authorizedUserId,
            time: msg.time,
            data: [msg],
          });
        }
      }

      return Object.entries(groupedByDate).map(([date, data]) => ({
        date,
        data,
      }));
    }
  } catch (error) {
    console.log(error);
  }
}

export default function ChatMessages({
  messages = [],
  onScroll = async () => {},
  onDeleteMessage = async () => {},
  chatId,
  meassageLoading = true,
  meassageFetching = true,
}) {
  const messageContainerRef = useRef(null);
  const today = dayjs(new Date()).format("DD MMM, YYYY");
  const [unread, setUnread] = useState([]);

  // const messages = [
  //   {
  //     attachment: { url: null },
  //     authorizedUserId: "67cac51d3dc4c170f21009b2",
  //     chatId:"",
  //     isMe: true,
  //     name: "Admin1 Vpeters",
  //     sendBy: "67cac51d3dc4c170f21009b2",
  //     senderImage: { url: null },
  //     text: "Hi siru i'm admin from vpeters.",
  //     time: "2025-04-23T13:47:22.572Z",
  //     _id: "6808ef6a86ae8a7b232fcd01",
  //   },
  // ];

  function tapToBottom() {
    const container = messageContainerRef.current;
    if (!container) return;

    container.scrollTop = container.scrollHeight;
  }

  return (
    <Fancybox
      options={{
        Carousel: {
          infinite: false,
        },
      }}
      className="relative h-full overflow-hidden flex flex-col"
    >
      {meassageFetching && (
        <div className="sticky top-1 text-xs text-chestnut-rose z-10">
          <div className="flex items-center justify-center gap-2 absolute w-full top-full left-0 text-center">
            <i
              className={classNames(
                "fa-fw fa-duotone fa-solid fa-spinner-third animate-spin"
              )}
            ></i>
            Fetching new message...
          </div>
        </div>
      )}

      {groupMessages(messages)?.length > 0 && (
        <MessageViewer
          today={today}
          messages={groupMessages(messages)}
          onScroll={onScroll}
          chatId={chatId}
          unread={unread}
          setUnread={setUnread}
          ref={messageContainerRef}
          onDeleteMessage={onDeleteMessage}
        />
      )}
      {/* {unread?.length > 0 && (
        <div className="sticky top-full z-10">
        <div className="absolute bottom-full right-4">
        <button
              type="button"
              className="bg-chestnut-rose w-10 aspect-square shadow rounded-full flex justify-center items-center text-white text-sm"
              onClick={tapToBottom}
              >
              {unread?.length > 99 ? "99+" : unread?.length}
              </button>
              </div>
              </div>
              )} */}
    </Fancybox>
  );
}
